import { createFileRoute } from "@tanstack/react-router";
import RoofReplacement from "@/pages/services/RoofReplacement";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { roofReplacementFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/roof-replacement")({
  head: () =>
    seo({
      title: "Roof Replacement in Minneapolis, MN | Cedar Creek Construction",
      description:
        "Full tear-off asphalt shingle roof replacement in Minneapolis & the Twin Cities. GAF & Owens Corning systems, insurance-claim help, and free estimates from a licensed local crew.",
      path: "/services/roof-replacement",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/roofing" },
          { name: "Roof Replacement", path: "/services/roof-replacement" },
        ]),
        buildServiceSchema({
          name: "Roof Replacement in Minneapolis, MN",
          serviceType: "Roof Replacement",
          url: absoluteUrl("/services/roof-replacement"),
          description:
            "Complete tear-off and asphalt shingle roof replacement for homes across Minneapolis and the Twin Cities metro, using GAF and Owens Corning roofing systems with manufacturer-backed warranties.",
        }),
        buildFaqPageSchema(roofReplacementFaqs),
      ],
    }),
  component: RoofReplacement,
});
